<div class="api-reference-management-cards">
  <h3 class="title-heading">{{ titleHeading }}</h3>
  <div class="row">
    <div class="card-container col-sm-12 col-lg-3 col-md-6" *ngFor="let apiReferenceManagementCard of apiReferenceManagementCards">
      <div class="card">
        <h4 class="card-title">
          <a class="title" href="{{ apiReferenceManagementCard.titleLink }}">{{ apiReferenceManagementCard.title }}</a>
        </h4>
        <div class="image-tile-container">
          <div class="outer-tile">
            <div class="image-tile show-image" style="background-image: url('{{ apiReferenceManagementCard.headImage }}');"></div>
          </div>
        </div>
        <div class="list-group">
          <div class="api-reference-management-card-body" [innerHtml]="returnHtmlFromRichText(apiReferenceManagementCard.richTextBody) | mdToHtml"></div>
          <div class="button-center">
            <a href="{{ apiReferenceManagementCard.titleLink }}" class="btn btn-outline-primary">
              {{ apiReferenceManagementCard.buttonText }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
